import { render, staticRenderFns } from "./SalesLeaveSelfService.vue?vue&type=template&id=77681e56&scoped=true&"
import script from "./SalesLeaveSelfService.vue?vue&type=script&lang=js&"
export * from "./SalesLeaveSelfService.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeaveSelfService.vue?vue&type=style&index=0&id=77681e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77681e56",
  null
  
)

export default component.exports